import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import { useAppSelector } from "../../../../shared/store";
import circleExclamation from "../../../../shared/assets/icons/circleExclamation.svg";
import { SearchInput } from "../../../../shared/ui/SearchInput";
import clsx from "clsx";
import { getAmountRanges } from "../../../../shared/store/payment/api";
import { Button } from "../../../../shared/ui/Button";
import { updateOfferAmount } from "../../../../shared/store/payment/api";



export const WaitingAmountChoice = () => {
  const offerData = useAppSelector((state) => state.payment.offer);
  const [sumFilter, setFilter] = useState("");
  const [activeSum, setActiveSum] = useState("");
  const [amountRanges, setAmountRanges] = useState<string[]>([]);
  const [warn, setWarn] = useState<string>("");

  const changeFilter = (value: string) => {
    setFilter(value);
  };
  const amountRangesReq = async () => {
    if (offerData) {
      const resp = await getAmountRanges(offerData.id);
      setAmountRanges(resp);
    }
  };

  const updateAmount = async () => {
    if (offerData) {
      const resp = await updateOfferAmount(offerData.id, activeSum);
      if (!resp.success) {
        setWarn("Произошла ошибка");
      }
    }
  };

  useEffect(() => {
    const offerRequest = setInterval(() => {
      amountRangesReq();
    }, 1000);
    return () => {
      clearInterval(offerRequest);
    };
  }, []);

  const sumsFiltered = amountRanges.sort(function (a, b) {
    const filterParam = sumFilter?sumFilter: offerData?.amountFiat
    return (
      Math.abs(Number(filterParam) - Number(a)) -
      Math.abs(Number(filterParam) - Number(b))
    );
  });
  return offerData ? (
    <div className={styles.wrap}>
      <section className={styles.card}>
        <h2 className={styles.title}>Пополнение</h2>
        <p className={styles.order_title}>{`ID заказа: ${offerData.id}`}</p>

        <div className={styles.selected_amount}>
          <div className={styles.selected_value}>
            {activeSum
              ? `${activeSum} ${offerData.fiatCode}`
              : `${offerData.amountFiat} ${offerData.fiatCode}`}
          </div>
          <div className={styles.selected_subtitle}>Без комиссии</div>
        </div>

        <div className={styles.benefits}>
          <div className={`${styles.benefit} ${styles.benefit_green}`}>
            <span className={styles.dot} />
            Автоперерасчёт
          </div>
          <div className={styles.benefit}>
            <span className={styles.dot} />
            Доступные суммы онлайн
          </div>
          <div className={styles.benefit}>
            <span className={styles.dot} />
            Можно выбрать любую
          </div>
        </div>

        <div className={styles.warning}>
          <img src={circleExclamation} alt="alert" className={styles.warning_icon} />
          <div>
            <p className={styles.warning_title}>Выберите другую сумму оплаты</p>
            <p className={styles.warning_text}>
              {`На сумму ${offerData.amountFiat} ${offerData.fiatCode} сейчас нет доступных реквизитов. Пожалуйста, выберите другую сумму пополнения из списка ниже. `}
              <span className={styles.subtle_strong}>По заявке будет выполнен автоматический перерасчёт.</span>
            </p>
          </div>
        </div>

        <SearchInput
          className={styles.search}
          value={sumFilter}
          onChangeCallback={changeFilter}
          placeholder="Поиск по суммам"
        />

        <div className={styles.amounts_frame}>
          <ul className={styles.amounts}>
            {sumsFiltered.map((el, index) => (
              <li key={index}>
                <button
                  type="button"
                  onClick={() => setActiveSum(el)}
                  className={clsx(styles.chip, el === activeSum && styles.chip_active)}
                >
                  {`${el} ${offerData.fiatCode}`}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className={styles.action_card}>
        {activeSum && (
          <div className={styles.action_summary}>
            <span className={styles.dot} />
            <span>Вы выбрали: <strong>{`${activeSum} ${offerData.fiatCode}`}</strong></span>
          </div>
        )}
        <Button
          onClick={updateAmount}
          className={styles.pay_btn}
          variant="primary"
          content={!activeSum ? "Выберите сумму" : "Создать заявку"}
          disabled={!Boolean(activeSum)}
        />
        <div className={styles.subhint}>Доступные суммы обновляются автоматически.</div>
        {warn && <div className={styles.btn_warn}>{warn}</div>}
      </section>
    </div>
  ) : (
    <></>
  );
};
